/**
 * @Author: Zero
 * @Date: 2023-12-26 09:54:24
 * @Explain: 活动报表 - 英文
 */

export default {
  // 跳转活动详情失败提示
  'ACTIVITY.REPORT.TO.DETAIL.FAIL.TRY': 'Activity does not exist',
  // 列表
  'ACTIVITY.REPORT.TITLE': 'Campaign reports',
  'ACTIVITY.REPORT.SUB.TITLE': 'Reports overview',
  'ACTIVITY.REPORT.ACTIVITY.STATUS.ON.GOING': 'Sending',
  'ACTIVITY.REPORT.ACTIVITY.STATUS.COMPLETED': 'Completed',
  'ACTIVITY.REPORT.ACTIVITY.CAMPAIGN': 'Campaign',
  'ACTIVITY.REPORT.ACTIVITY.GROUP': 'Campaign groups',
  'ACTIVITY.REPORT.ACTIVITY.GROUP.BUBBLE.1':
    'Grouped campaigns will generate a single report with the aggregated metrics of these campaigns.',
  'ACTIVITY.REPORT.ACTIVITY.GROUP.BUBBLE.2':
    'The metrics of contacts who are targeted in multiple campaigns will be counted independently in each campaign.',
  'ACTIVITY.REPORT.LIST.GROUP.TITLE': 'List of campaign groups',
  'ACTIVITY.REPORT.ACTIVITY.GROUP.LOADING.TEXT':
    'Data loading in progress {num}s ...',
  'ACTIVITY.REPORT.LIST.NAME': 'Campaign name',
  'ACTIVITY.REPORT.LIST.CLASSIFICATION': 'Campaign type',
  'ACTIVITY.REPORT.LIST.STATUS': 'Status',
  'ACTIVITY.REPORT.LIST.SEND.DATE': 'Send date',
  'ACTIVITY.REPORT.LIST.RECIPIENT': 'Recipients',
  'ACTIVITY.REPORT.LIST.SENT': 'Sent',
  'ACTIVITY.REPORT.LIST.FORMULA.SENT': 'Send rate = Sent / Recipients',
  'ACTIVITY.REPORT.LIST.DELIVERED': 'Delivered',
  'ACTIVITY.REPORT.LIST.FORMULA.DELIVERED': 'Delivery Rate = Delivered / Sent',
  'ACTIVITY.REPORT.LIST.OPENED': 'Opened',
  'ACTIVITY.REPORT.LIST.FORMULA.OPENED': 'Open Rate = Opened / Delivered',
  'ACTIVITY.REPORT.LIST.CLICKED': 'Clicked',
  'ACTIVITY.REPORT.LIST.FORMULA.CLICKED':
    'Click-to-open Rate = Clicked / Opened',
  'ACTIVITY.REPORT.LIST.ACTION.VIEW': 'View report',
  'ACTIVITY.REPORT.VIEW.DETAILS': 'Campaign details',
  'ACTIVITY.REPORT.VIEW.REPORT': 'View report',
  'ACTIVITY.REPORT.LIST.STATUS.CYCLE': 'Cycle {num}',
  'ACTIVITY.REPORT.LIST.GROUP.UPDATE.DATA': 'Update metrics',
  'ACTIVITY.REPORT.LIST.GROUP.UPDATE.DATA.TIPS': 'Last update:{time}',
  'ACTIVITY.REPORT.LIST.NO.ACTIVITY.GROUP.TIPS':
    'There are no activities within the group.',
  'ACTIVITY.REPORT.LIST.GROUP.CREATE': 'Create campaign group',
  'ACTIVITY.REPORT.LIST.GROUP.EDIT': 'Edit campaign group',
  'ACTIVITY.REPORT.LIST.GROUP.NAME': 'Campaign group name',
  'ACTIVITY.REPORT.LIST.GROUP.NAME.PLACEHOLDER': 'Enter group name',
  'ACTIVITY.REPORT.LIST.GROUP.CAMPAIGN.BUBBLE':
    'Only regular (non-recurring) campaigns can be grouped together',
  'ACTIVITY.REPORT.LIST.GROUP.NAME.REPEAT':
    'This name is already being used, please use a different name',
  'ACTIVITY.REPORT.LIST.GROUP.CAMPAIGN': 'Campaigns to include',
  'ACTIVITY.REPORT.LIST.GROUP.CAMPAIGN.SEARCH': 'Search campaign',
  'ACTIVITY.REPORT.LIST.GROUP.NAME.LIMIT':
    'Enter the campaign group name, the maximum character limit is {num}',
  'ACTIVITY.REPORT.LIST.GROUP.CAMPAIGN.LIMIT': 'Select campaigns',
  'ACTIVITY.REPORT.LIST.GROUP.CAMPAIGN.MAX.ACTIVITY':
    'This group has reached its maximum number of campaigns',
  'ACTIVITY.REPORT.LIST.GROUP.DEL.TITLE':
    'Are you sure you want to delete this campaign group?',
  'ACTIVITY.REPORT.LIST.GROUP.DEL.DESC':
    'After deleting <span class="color-primary font-weight-700">{name}</span>, the campaign group data cannot be restored.',
  // 详情
  'ACTIVITY.REPORT.DETAIL.SEARCH.ACTIVITY': 'Switch campaign',
  'ACTIVITY.REPORT.DETAIL.SEARCH.ACTIVITY.PLACEHOLDER': 'Search campaign',
  'ACTIVITY.REPORT.DETAIL.SEARCH.PERIOD': 'Switch cycle',
  'ACTIVITY.REPORT.DETAIL.SEARCH.PERIOD.PLACEHOLDER': 'Enter the cycle name',
  'ACTIVITY.REPORT.DETAIL.SELECT.ACTIVITY': 'Select campaign',
  // Overview
  'ACTIVITY.REPORT.DETAIL.TAB.OVERCIEW': 'Overview',
  'ACTIVITY.REPORT.DETAIL.TAB.CLICK.PERFORMANCE': 'Click performance',
  'ACTIVITY.REPORT.DETAIL.REGION': 'Region',
  // Deliverability
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.TITLE': 'Delivery metrics',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DESC':
    'These delivery metrics show the performance data of the email campaign that is delivered to your contacts. These metrics are usually related to the quality of your contacts list and the reputation of the sender\'s email domain. <a href="{url}" target="_blank">Read more</a>',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.IN.BACKLOG':
    '{num} in backlog',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.TITLE': 'Delivered',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.RECIPIENTS':
    'Recipients',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.DESC.RECIPIENTS':
    'The total number of recipients based on campaign settings',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.SENT': 'Sent',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.DESC.SENT':
    'Number of emails sent',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.DELIVERED':
    'Delivered',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.DESC.DELIVERED':
    "Number of messages successfully delivered to users' email server",
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.RATE.TITLE.DELIVERED':
    'Delivery Rate',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.RATE.FORMULA.DELIVERED':
    'Delivery Rate = Delivered / Sent',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.DELIVERY.DELIVERED.DESC':
    'Delivery Rate <span class="font-size-14 color-333 font-weight-700">{deliverRate}</span>',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED':
    'Filtered out',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.DETAILS':
    'Filter details',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.FILTERED.L':
    '{filtered} contacts filtered out by ',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.FILTERED.C':
    'Blocklist',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.FILTERED.R':
    '',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.RULEFILTRATIONNUM':
    '{filtered} contacts filtered out by <a href="{url}" target="_blank" style="text-decoration: none;">SLHP</a> (SmartLink List Hygiene Protection)',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.STRATEGY.L':
    '{strategyCount} filtered by ',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.STRATEGY.C':
    "'Email frequency controls'",
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.FILTERED.BY.STRATEGY.R':
    '',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.BACKLOGS.DESC':
    'Delivery delayed due to ISP limitations',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.BACKLOGS': 'Backlog',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.SOFT.BOUNCE':
    'Soft bounce',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.SOFT.BOUNCE.DESC':
    'Usually a temporary problem (e.g., the recipient’s inbox is full)',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.HARD.BOUNCE':
    'Hard bounce',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.HARD.BOUNCE.DESC':
    'Usually a permanent problem (e.g., non-existent address)',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.TITLE':
    'Non-delivery metrics',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.VIEW.MORE':
    'View more',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.NOT.SENT':
    'Not sent',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.BOUNCED': 'Bounced',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.DETAILS': 'Details',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.COUNT': 'Count',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.PERCENTAGE':
    'Percentage',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.DELEVERABILITY.ANALYSIS.DESC': 'Description',
  // Email engagement
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.TITLE': 'Email engagement',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.DESC':
    'These metrics show the attractiveness of your email/campaign content for your audience.',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.ENG.RES': 'Engagement results',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.OPENED': 'Opened',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.CLICKED': 'Clicked',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.UNSUB': 'Unsubscribed',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.RATE': 'Rate',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.AFTER': 'Later',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.VIEW.DETAILS':
    'View details by region or language',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.CTOR': 'CTOR',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.OPENED': 'Rate',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.DESC.OPENED':
    'Open rate = Opened / Delivered',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.CLICKED': 'CTOR',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.DESC.CLICKED':
    'CTOR = Clicked / Opened',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.UNSUB': 'Rate',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.INFO.DESC.UNSUB':
    'Unsubscribe Rate = Unsubscribed / Opened',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.TITLE': 'Benchmarks',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.INFO':
    'Compare performance of this campaign with your other campaigns or with campaigns from other projects. You can also specifically select one of your other campaigns to compare against. (Campaigns with less than 50 recipients are not included)',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.DESC':
    'Compare campaign performance',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.TAB1': 'Open Rate',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.TAB2': 'Click to Open Rate',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.TAB3': 'Unsubscribe Rate',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.COMPARE':
    'Compare performance with',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.ACTIVITY.PERFORMANCE':
    'Show performance of other campaigns from this project',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.PERF':
    'Performance of this campaign',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.AVG':
    'Average performance of all your other campaigns',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.BETTERS.AVG':
    'Average performance of all campaigns from other projects',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.BETTER':
    'Percentage of campaigns <span class="font-weight-700">in this project</span> <br/>that this campaign is outperforming',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.BETTERS':
    'Percentage of campaigns <span class="font-weight-700">in other projects</span> <br/>that this campaign is outperforming',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.ACTIVITY.TYPE':
    'Filter by type',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.ACTIVITY.TYPE.OTHER': 'All',

  // Conversions
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.TITLE': 'Conversion',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.DESC':
    'These metrics show the conversion results of your campaign. This requires your in-app data to be connected through the <a href="{ url }" target="_blank">SmartLink API</a>.',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.GUIDE.TITLE':
    'Get an in-depth analysis of your <br/>email performance',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.GUIDE.DESC':
    'Dive deeper into the metrics that matter most to you. Chart these metrics and view their performance over time.',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.INDIC.METRIC':
    'Select a metric you want to track',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.INDIC.NAME': 'API name',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.INDIC.FILEDS.REQ': 'Field required?',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.INDIC.READY': 'Ready？',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.GUIDE.BTN': 'Customize Metrics',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.REGISTERED': 'Registered user',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.ACTIVE': 'Login user',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.PAY': 'Paying user',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.CLOUMNS.1': 'Registered Users',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.CLOUMNS.2': 'Active Users',
  'ACTIVITY.REPORT.DETAIL.OVERCIEW.CONVER.CLOUMNS.3': 'Paying Users',
  'ACTIVITY.REPORT.DETAIL.COUNT': 'Count',
  // Click performance
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.TITLE': 'Click Summary',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.OPEN.TITLE': 'Click-to-open Rate',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.OPEN.DESC.UC': ' unique clicks ',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.OPEN.DESC.UQ': ' unique opens',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.STATIS.TITLE': 'Statistics',
  'ACTIVITY.REPORT.DEFAULT.LANGUAGE': 'Default',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.STATIS.TITLE.NEW': 'Split-View',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.URL': 'By URL',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.LABEL': 'By labels',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.LIST': 'View List',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP': 'View Heatmap',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.PREVIEW.TITLE': 'Email Preview',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.CLICK.SUMMARY': 'Click Summary',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.TOTAL.CLICK.SUMMARY.BY.LANG': 'Total clicks',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.TOTAL.CLICK.SUMMARY.BY.LANG.DES': 'Counts every single click. If one person clicks a link 3 times, it counts as 3.',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.UNIQUE.CLICK.SUMMARY.BY.LANG': 'Unique clicks',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.UNIQUE.CLICK.SUMMARY.BY.LANG.DES': 'Counts the number of people. If one person clicks a link 3 times, it counts as 1.',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.LIST.TITLE': 'Top URLs',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.LIST.HEADER.URL': 'URL',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.LIST.HEADER.CLICK': 'Total clicks',

  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.LIST.HEADER.CLICK.UNIQUE': 'Unique clicks',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.HOVER.TOTAL.TIP': 'Total clicks ({num})',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.HOVER.UNIQUE.TIP': 'Unique Clicks ({num})',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.HOVER.HOT.TIP': 'Hot Clicks ({num})',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.HOVER.MIDDLE.TIP': 'Medium Clicks ({num})',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.DISPLAY.BY.HOTMAP.HOVER.COLD.TIP': 'Cold Clicks ({num})',

  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.EMAIL.LANG': 'By email language',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.URL.DESC':
    'View click data by URL (filtered by Labels and Email Languages)',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.LABEL.DESC':
    'View click data by Label. Set up Labels in the email template or ',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.LABEL.DESC.GO':
    '[Go to settings]',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.BY.EMAIL.LANG.DESC':
    'View click data by Email Language',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.LABEL': 'Label',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.EMAIL.LANG': 'Email language',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.TOTAL.CLICKS': 'Total clicks',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.UNIQUE.CLICKS': 'Unique clicks',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.CLICK.OPEN': 'Click-to-open Rate',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.SEARCH.URL': 'Enter a URL',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.EDIT.URL':
    'Edit URL label in emails',
  'ACTIVITY.REPORT.DETAIL.CLICKPERF.SUMMARY.ALL.LANG': 'All email languages',
  // In-game Behavior Analysis
  'ACTIVITY.REPORT.DETAIL.TAB.BEHAVIOR': 'In-game Behavior Analysis',

  // AB Test报表
  'ACTIVITY.REPORT.VIEW.SETUP.BTH.TITLE': 'Campaign details',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.EMAIL': 'View email',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.DETAIL.BUTTON': 'View test setup',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.STATUS.2': 'Testing has ended',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.STATUS.4': 'Testing in progress',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.STATUS.5': 'Testing Paused',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.STATUS.7': 'Testing Completed',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SEND.TIME': 'send on {sendTime}',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.EXP.NUM':
    '<span class="mark">{expGroupNum}</span> setups',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LANG.NUM':
    'Devided by <span class="mark">{langNum}</span> languages',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST': 'A/B test performance',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.CAMP': 'Execution performance',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.PREFIX':
    'The winning setup is scheduled to send 1 day after the test delivery is completed,',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.PAUSE':
    'Activity was paused',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.DISABLED':
    'Activity was manually terminated',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.TEST.ON.GOING':
    'Pending manual decision. ',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.TEST.ON.GOING.FINISH':
    'Pending manual decision until  <span class="mark">{time}</span>,',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.REMAIN.ON.GOING.FINISH':
    'Winning variation is <span class="mark">{winner}</span> (for {lang}). Emails to the remaining recipients were sent on <span class="mark">{time}</span>{point}',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.OPERATE.REMAIN.ON.GOING.FINISH.NO.LANG':
    'Winning variation is <span class="mark">{winner}</span>. Emails to the remaining recipients were sent on <span class="mark">{time}</span>{point}',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.AUTO.TEST.ON.GOING':
    'The winner will be decided <span class="mark">{time}</span> after the test phase has finished.',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.AUTO.TEST.ON.GOING.FINISH':
    'The winning variation will start delivery on <span class="mark">{time}</span>,',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.AUTO.REMAIN.ON.GOING.FINISH':
    'Winning variation is <span class="mark">{winner}</span> (for {lang}). Emails to the remaining recipients were sent on <span class="mark">{time}</span>{point}',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.TIP.AUTO.REMAIN.ON.GOING.FINISH.NO.LANG':
    'Winning variation is <span class="mark">{winner}</span>. Emails to the remaining recipients were sent on <span class="mark">{time}</span>{point}',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.DETAIL.SUFFIX':
    'See details',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.CONVERT.SUFFIX':
    'Select manually',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.CONVERT.SUFFIX.AUTO':
    'After sending, you can manually select',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.NOW.SUFFIX':
    'Select manually',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.DISABLED':
    'Please wait until the test is completed and select manually',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TAB.ABTEST.WIN.SELECT.COMPETITION':
    'Comparison',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LANG.ALL': 'All languages',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.ALL': 'All',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BY.LANG': 'language',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.REGION.ALL': 'All regions',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BY.REGION': 'region',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND': 'Trend',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL': 'Details',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.TYPE.OPEN.RATE': 'Open Rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.TYPE.CLICK.RATE': 'Click Rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.TYPE.SENT.RATE': 'Sent Rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.TYPE.UNSUB.RATE': 'Unsubscribe Rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.CYCLE.HOUR': 'By Hour',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.CYCLE.HOUR.TIP': '{num} Hour',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.CYCLE.DAY': 'By Day',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.CYCLE.DAY.TIP': '{num} Day',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.LANG': 'Language',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.WINNER': 'Winner',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.SUBJECT': 'Subject',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.PREVIEW':
    'Preview text',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.SETUP': 'Variation',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.RECIPIENT':
    'Recipients',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.DELIVER': 'Delivered',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.DELIVER.RATE':
    'Delivery rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.OPEN.RATE': 'Open rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.CTOR.RATE':
    'Click rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.TABLE.UNSUB.RATE':
    'Unsubscribe rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.DETAIL.CHECK.TIP':
    'Experiencing delivery issues? View campaign performance',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.COMPARE': 'Metrics comparison',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.COMPARE.SELECT.TIP': 'Compare',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.COMPARE.SELECT.BY': 'By',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.COMPARE.SELECT.LANG': 'Language',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.TREND.COMPARE.SELECT.REGION': 'Region',

  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TITLE':
    'Select winning setup',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.DISABLE.SELECT':
    'The winning setup of all languages must be selected',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.CONTENT.TITLE':
    'Winner selection',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.CONTENT.SUBTITLE':
    'Select a single winner for all audiences or a different winner for each audience. The winner will be delivered automatically to the remaining audience.',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.DILIVER.LANG':
    'Devide by language',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.DILIVER.SWITCH.OPEN':
    'Organise the languages',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.DILIVER.LANG.TIP':
    "We will merge the following languages into an '<span class='mark'>others</span>' group, ensuring sufficient recipients per setup.",
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.OTHERS': 'Others',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.TABLE.OTHERS': 'Others',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.OTHERS.TIP':
    'Combined languages',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.DISABLED.SPLIT':
    'Different winner',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.LANG.SPLIT':
    'Single winner',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.SETUP': 'Setup',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.LINE.SETUP':
    'Variation{num}',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TIP.SETUP': 'Variation',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.RECIPIENT':
    'Recipients',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.SENT': 'SENT',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.DILIVERED':
    'Delivered',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.DILIVERED.RATE':
    'Deliver rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.OPEN.RATE':
    'Open rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.CTOR.RATE': 'CTOR',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.WIN.DIALOG.TABLE.UNSUB.RATE':
    'Unsubscribe rate',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.CAMPAIGN.ALL': 'The whole campaign',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.CAMPAIGN.ONLY.AB':
    'Only count the A/B test part',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.SELECT.CAMPAIGN.EXCLUDE.AB':
    'Exclude the A/B test part',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LINE.START': 'Start',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LINE.NOW': 'Now',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LINE.HOUR': 'hours',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LINE.DAY': 'days',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.LINE.END': 'Afterwards',

  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.TITLE': 'A/B test setup details',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.STEUP.NUMBER': 'Variations:',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.DEFAULT.LANG': 'Default language:',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.VARIATIONS': 'Variation',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.GROUP.SIZES': 'Group size',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.SUBJECT': 'Subject',
  'ACTIVITY.REPORT.VIEW.SETUP.DETAILS.PREVIEW.TEXT': 'Preview text',
  'ACTIVITY.REPORT.AB.TEST.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.BETTER':
    'Percentage of campaigns <span class="font-weight-700">in this project</span> <br/>that this setup is outperforming',
  'ACTIVITY.REPORT.AB.TEST.DETAIL.OVERCIEW.EMAIL.BENCHMARKS.BETTERS':
    'Percentage of campaigns <span class="font-weight-700">in other projects</span> <br/>that this setup is outperforming',
  'ACTIVITY.REPORT.AB.TEST.SRTIP.SUBJECT': 'Setup {num}',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TITLE.1': 'Trend: Registered Users',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TOTAL.1': 'Registered Users',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.RATE.1': 'Registered Users (Ratio)',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TITLE.2': 'Trend: Login Users',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TOTAL.2': 'Login Users',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.RATE.2': 'Login Users (Ratio)',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TITLE.3': 'Trend: Paying Users',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.TOTAL.3': 'Paying Users',
  'ACTIVITY.REPORT.AB.TEST.CONVER.TREND.RATE.3': 'Paying Users (Ratio)',

  // 周期活动选中全部周期抽屉
  'ACTIVITY.REPORT.CYCLE.ALL': 'All cycles',
  'ACTIVITY.REPORT.RECCURING.REPORT.TITLE': 'Recurring campaigns report',
  'ACTIVITY.REPORT.RECCURING.REPORT.ALL.CYCLE.TITLE': 'All cycles',
  'ACTIVITY.REPORT.RECCURING.REPORT.ALL.CYCLE.DESC':
    'The performance results for all cycles is derived from the results in all individual cycles. Data from the same contact will not be merged, instead it will be summed over all cycles.',
  'ACTIVITY.REPORT.RECCURING.REPORT.EMAIL.PART.TITLE': 'Email engagement',
  'ACTIVITY.REPORT.RECCURING.REPORT.EMAIL.PART.DESC':
    'The engagement results for all cycles is derived from the results in multiple cycles. For example, the engagement results for D1 is the combined data of D1 in all cycles.',
  'ACTIVITY.REPORT.RECCURING.REPORT.REMBER.BOX':
    'Do not automatically expand this description',

  // abTest v4.0.0报表详情
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.ACTION.SELECT.NOW': 'Select now',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.ACTION.SWITCH.MANUAL':
    'Switch to manual winner selection',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.ACTION.VIEW.DETAILS':
    'View details for all languages',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.ACTION.RESTART.CAMPAIGN':
    'Restart campaign',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.1': 'Pending manual selection. ',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.2':
    'The winner will be automatically delivered <b class="color-000">{intervalTime} {intervalTypeText}</b> after the test phase has been completed. ',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.3':
    'Pending manual selection (deadline: <b class="color-000">{expNodeTime}</b>).',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.4':
    'The winner will start being delivered on <b class="color-000">{expNodeTime}</b>. ',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.5':
    'Variation <b class="color-000">{winnerExpNum}</b> was selected and delivery to the remaining recipients started on <b class="color-000">{expNodeTime}</b>',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.6':
    'Variation <b class="color-000">{winnerExpNum}</b> was selected for <b class="color-000">{winnerExpLang}</b> and delivery to the remaining recipients started on <b class="color-000">{expNodeTime}</b>. ',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.7':
    'Campaign has been suspended on <b class="color-000">{suspendTime}</b>. ',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.8':
    'Variable value is missing, campaign has been interrupted.Click on the key name to upload the variable value for it: ',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.9':
    'Campaign was terminated by <b class="color-000">{terminateBy}</b> on <b class="color-000">{terminateTime}</b>',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.10':
    'Recipients have all been added to the test group. As a result there is no winner selection or delivery.',
  'ACTIVITY.REPORT.VIEW.SETUP.ABTEST.BANNER.11': 'Test is completed.',
  /** 报表 - 导出链接点击次数页面相关 **/
  'ACTIVITY.REPORT.LINKS.CLICKED.TITLE': 'Links Clicked',
  'ACTIVITY.REPORT.LINKS.CLICKED.SEARCH.PLACEHOLDER': 'Search Email',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.BUTTON': 'Export As CSV',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.DIALOG.CONTENT':
    'Are you sure you want to export the click details for <b class="color-333">{campaignName}</b>?',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.DIALOG.HEADER': 'Confirm Export',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.ENTER.BUTTON': 'Export',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.COLUMNS.EMAIL.ADDRESS.TITLE':
    'Email Address',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.COLUMNS.TIMESTAMP.TITLE': 'Timestamp',
  'ACTIVITY.REPORT.LINKS.CLICKED.EXPORT.COLUMNS.URL.TITLE': 'URL',
  'ACTIVITY.REPORT.LINKS.CLICKED.CREATED.EXPORT.REQUEST.SUCCESS':
    'Export task submitted successfully. Please go to the <b class="color-primary">Export Center</b> to download the file.',
  'ACTIVITY.REPORT.LINKS.CLICKED.CREATED.EXPORT.REQUEST.FAILED':
    'Export failed, please retry.',
};
